// Get all the products
export const XXXgetOrders = state => {
  return state.orders;
}
